import styled from 'styled-components';

export const Aside = styled.aside`
    width: 18.6046511627907%;

    span {
        font-weight: 500;
        font-size: 1rem;
        line-height: 1.25rem;
        color: #eb5757;
    }

    p {
        margin-top: 10px;
        padding: 20px;
        background-color: #ffefe8;
        border-radius: 5px;
        font-weight: 400;
        font-size: 0.875rem;
        line-height: 1.125rem;
    }
`;
